import { TGuardadoParciaModel } from '@/models/GuardadoParcial.model';
import { encryptWithPublicPem } from '@/utils/jweEncryptionService';

export class GuardadoParcialHelper {

  static async cifrarDatosEntrada(request: TGuardadoParciaModel, publicKeyPem: string): Promise<any> {

    if (!request || !request.EntradaGuardadoParcial) {
      throw new Error('Invalid request data');
    }


    const encryptedData = await encryptWithPublicPem(request, publicKeyPem);

    return encryptedData;
  }
}
